import React, { useEffect, useState } from 'react';
import { InputMask } from 'primereact/inputmask';

import '../../static/css/main.css'
import '../../static/css/animate.css'
import '../../static/fonts/stylesheet.css'
import '../../static/css/enjoyhint.css'

import sber from "../../static/img/sber.png"
import rifizen from "../../static/img/rifizen.png"

import icon_home_gray from "../../static/img/icon-home-gray.svg"
import icon_heart_gray from "../../static/img/icon-heart-gray.svg"

import burger_2 from '../../static/img/burger-2.png'

import heart from "../../static/img/heart.svg"

import icon_s3_1 from "../../static/img/icon-s3-1.svg"
import icon_s3_2 from "../../static/img/icon-s3-2.svg"
import arrow_dropdown_gray from "../../static/img/Arrow_dropdown-gray.svg"

import absolut_logo from '../../static/logo/absolut-logo.png'
import zetta_logo from '../../static/logo/zetta-logo.png'
import pari_logo from '../../static/logo/pari-logo.png'
import vsk_logo from '../../static/logo/vsk-logo.png'

import { PreCalcHeader } from './header';
import { pre_calc_title } from './title';
import { PreCalcFooter } from './footer';
import { DropDownObject } from './widgets/dropDownObject';
import { DropDownBank } from './widgets/dropDownBank';
import { useDispatch, useSelector } from 'react-redux';
import { selectCookie, selectLifeOption, selectMortgageBalance, selectPropertyOption, selectToken, selectTokenVsk, setCookie, setLifeOption, setMortgageBalance, setPropertyOption, setToken, setTokenVsk } from './precalcSlice';
import { getDescription, getTokens, preCalcNew, preCalculate } from './precalcApi';
import { clear_arrs, fetchAbsoluteData, fetchPariData, fetchZettaData, selectIdBank, selectIndexLifeMin, selectIndexLifePop, selectIndexLifeSame, selectIndexPropertyMin, selectIndexPropertyPop, selectIndexPropertySame, selectListCompaniesLife, selectListCompaniesProperty, selectTypeObject, setAmountPariL, setAmountPariP, setDescriptions, setIndexLifeMin, setIndexLifePop, setIndexLifeSame, setIndexPropertyMin, setIndexPropertyPop, setIndexPropertySame, setInsuranceCompanyLife, setInsuranceCompanyProperty, setListCompaniesLife, setListCompaniesProperty, setProcessCalc, setRatePariL, setRatePariP, setStepCalc, setTarifs, updateListCompaniesProperty } from '../calc/calcSlice';
import { digitNumber } from '../funcs/funcs';
import { selectShowPopUpManager, setCalcPage, setShowPopUpManager } from '../home/homeSlice';
import { OfferCard } from './widgets/offerCard';
import { selectBirthDateString, selectSex, setBirthDateString, setSex } from '../calc/personSlice';
import { FormManager } from '../home/formManager';
import { FormWait } from '../home/formWait';
import EnjoyHint from "xbs-enjoyhint/src/enjoyhint.js"
// import "xbs-enjoyhint/src/jquery.enjoyhint.css";




let raitings_p = [1, 2, 3, 4, 5, 6, 7];
let raitings_l = [1, 2, 6, 5, 4, 3];
let arr_companies_property = []

export function CalculateInsurance(props) {
    const dispatch = useDispatch()

    const [isLoad, setIsLoad] = useState(true);
    const [showMessengerSelecter, setShowMessengerSelecter] = useState(false);
    const showPopUpManager = useSelector(selectShowPopUpManager)

    const mortgageBalance = useSelector(selectMortgageBalance)
    const idBank = useSelector(selectIdBank)
    const cookie = useSelector(selectCookie)
    const token = useSelector(selectToken)
    const token_vsk = useSelector(selectTokenVsk)

    const sex = useSelector(selectSex)

    const list_companies_property = useSelector(selectListCompaniesProperty)
    const index_property_min = useSelector(selectIndexPropertyMin)
    const list_companies_life = useSelector(selectListCompaniesLife)
    const index_life_min = useSelector(selectIndexLifeMin)

    const lifeOption = useSelector(selectLifeOption)
    const propertyOption = useSelector(selectPropertyOption)

    const indexPropertyPop = useSelector(selectIndexPropertyPop)
    const indexLifePop = useSelector(selectIndexLifePop)
    const indexPropertySame = useSelector(selectIndexPropertySame)
    const indexLifeSame = useSelector(selectIndexLifeSame)
    const birthDateString = useSelector(selectBirthDateString)

    const typeObject = useSelector(selectTypeObject)

    const [showListCompanyProperty, setShowListCompanyProperty] = useState(false);
    const [showListCompanyLife, setShowListCompanyLife] = useState(false);
    const [showDataPolice, setShowDataPolice] = useState(false);
    const [showAnotherOffers, setShowAnotherOffers] = useState(false);
    const [isChangeParams, setIsChangeParams] = useState(true);
    const [showSexSelecter, setShowSexSelecter] = useState(false);

    const [emptyBirthDate, setEmptyBirthDate] = useState(false)
    const [emptyGender, setEmptyGender] = useState(false)
    const [notCompany, setNotCompany] = useState(false);

    const [showMessage, setShowMessage] = useState(false);

    const handleGetDescription = () => {
        // console.log('descr')
        getDescription({}, (data) => {
            dispatch(setDescriptions(data.descriptions))

            const arr_p = [data.descriptions['absolutproperty']?.raiting_pop,
            data.descriptions['zettaproperty']?.raiting_pop,
            data.descriptions['alfaproperty']?.raiting_pop,
            data.descriptions['pariproperty']?.raiting_pop,
            data.descriptions['ingosproperty']?.raiting_pop]

            const arr_l = [data.descriptions['absolutlife']?.raiting_pop,
            data.descriptions['zettalife']?.raiting_pop,
            data.descriptions['alfalife']?.raiting_pop,
            data.descriptions['parilife']?.raiting_pop,
            data.descriptions['ingoslife']?.raiting_pop]

            console.log('arr_p', arr_p)
            raitings_p = arr_p
            raitings_l = arr_l
        })
    }

    const handleClickCompanyProperty = () => {
        setShowListCompanyProperty(!showListCompanyProperty)
    }

    const handleClickCompanyLife = () => {
        if (lifeOption) setShowListCompanyLife(!showListCompanyLife)
        else {
            dispatch(setLifeOption(true))
            setIsChangeParams(true)
        }
    }

    function precalc(pars) {
        console.log('precalc', pars)
        setIsLoad(true)
        const timerCalc = setTimeout(() => {
            setShowMessage(true)
            clearTimeout(timerCalc)
        }, 60000)
        let arr_companies_life = []
        let arr_companies_property = []
        console.log('idBank', props.id_bank, idBank)
        preCalcNew({
            token: pars.token,
            cookie: pars.cookie,
            token_vsk: pars.token_vsk,
            limit_sum: pars.limit_sum,
            id_bank: pars.bank_id,
            sex: 'М',
            is_life: true,
            is_property: true,
            birthday: new Date('2000-01-01').toISOString().slice(0, -5),
        }, (data) => {
            clearTimeout(timerCalc)
            console.log('preCalcNew', data)
            handleGetDescription()
            if (data.premiums.property.length > 0) setIsLoad(false)
            console.log('preCalcNew', data)
            let min_ind = 0
            let min_premium_property = 1000000000
            let min_premium_life = 1000000000
            let index_raiting_p = 0
            let index_raiting_l = 0
            let maxRaitingP = 0
            let maxRaitingL = 0

            if ((data.premiums.property.length === 0 && propertyOption) || (data.premiums.life.length === 0 && lifeOption)) {
                setNotCompany(true)
                setIsLoad(false)
            }

            for (let i = 0; i < data.premiums.property.length; i++) {
                if (data.premiums.property[i].company === 'absolute') {
                    arr_companies_property.push({ logo: absolut_logo, company: 'Абсолют', premium: data.premiums.property[i].premium, is_manager: false, xname: 'absolutproperty', insur_comp: 'absolute' })
                    if (raitings_p[0] > maxRaitingP) {
                        maxRaitingP = raitings_p[0]
                        index_raiting_p = i
                    }
                }
                else if (data.premiums.property[i].company === 'zetta' && data.premiums.property[i].premium) {
                    arr_companies_property.push({ logo: zetta_logo, company: 'Зетта Страхование', premium: data.premiums.property[i].premium, is_manager: false, xname: 'zettaproperty', insur_comp: 'zetta' })
                    if (raitings_p[1] > maxRaitingP) {
                        maxRaitingP = raitings_p[1]
                        index_raiting_p = i
                    }
                }
                else if (data.premiums.property[i].company === 'pari' && data.premiums.property[i].premium) {
                    arr_companies_property.push({ logo: pari_logo, company: 'ПАРИ', premium: data.premiums.property[i].premium, is_manager: false, xname: 'pariproperty', insur_comp: 'pari' })
                    if (raitings_p[1] > maxRaitingP) {
                        maxRaitingP = raitings_p[2]
                        index_raiting_p = i
                    }

                    if (idBank === '2') {
                        dispatch(setTarifs(data.premiums.property[i].tarifs))
                    }
                    else {
                        dispatch(setAmountPariP(data.premiums.property[i].amount))
                        dispatch(setRatePariP(data.premiums.property[i].rate))
                    }
                }

                else if (data.premiums.property[i].company === 'vsk' && data.premiums.property[i].premium) {
                    arr_companies_property.push({ logo: vsk_logo, company: 'ВСК', premium: data.premiums.property[i].premium, is_manager: false, xname: 'vskproperty', insur_comp: 'vsk' })
                }

                if (data.premiums.property[i]?.premium) {
                    if (data.premiums.property[i].premium < arr_companies_property[min_ind].premium) {
                        min_ind = i
                    }
                    if (data.premiums.property[i].premium < min_premium_property) {
                        min_premium_property = data.premiums.property[i].premium
                    }
                }
            }
            dispatch(setListCompaniesProperty(arr_companies_property))
            dispatch(setIndexPropertyMin(min_ind))
            if (arr_companies_property.length > 0)
                dispatch(setInsuranceCompanyProperty(arr_companies_property[min_ind]?.insur_comp))

            min_ind = 0

            for (let i = 0; i < data.premiums.life.length; i++) {
                if (data.premiums.life[i].company === 'absolute') {
                    arr_companies_life.push(
                        {
                            logo: absolut_logo,
                            company: 'Абсолют',
                            premium: data.premiums.life[i].premium,
                            is_manager: false,
                            xname: 'absolutlife',
                            insur_comp: 'absolute'
                        })
                    if (raitings_l[0] > maxRaitingL) {
                        maxRaitingL = raitings_l[0]
                        index_raiting_l = i
                    }
                }
                else if (data.premiums.life[i].company === 'zetta' && data.premiums.life[i].premium) {
                    arr_companies_life.push(
                        {
                            logo: zetta_logo,
                            company: 'Зетта Страхование',
                            premium: data.premiums.life[i].premium,
                            is_manager: false,
                            xname: 'zettalife',
                            insur_comp: 'zetta'
                        })
                    if (raitings_l[1] > maxRaitingL) {
                        maxRaitingL = raitings_l[1]
                        index_raiting_l = i
                    }
                }
                else if (data.premiums.life[i].company === 'vsk' && data.premiums.life[i].premium) {
                    arr_companies_life.push(
                        {
                            logo: vsk_logo,
                            company: 'ВСК',
                            premium: data.premiums.life[i].premium,
                            is_manager: false,
                            xname: 'vsklife',
                            insur_comp: 'vsk'
                        })
                }
                else if (data.premiums.life[i].company === 'pari' && data.premiums.life[i].premium) {
                    console.log('pari life premium', data.premiums.life[i].premium)
                    arr_companies_life.push(
                        {
                            logo: pari_logo,
                            company: 'ПАРИ',
                            premium: data.premiums.life[i].premium,
                            is_manager: false,
                            xname: 'parilife',
                            insur_comp: 'pari'
                        })
                    if (raitings_l[2] > maxRaitingL) {
                        maxRaitingL = raitings_l[2]
                        index_raiting_l = i
                    }
                    dispatch(setAmountPariL(data.premiums.life[i].amount))
                    dispatch(setRatePariL(data.premiums.life[i].rate))
                    console.log('pari amount rate', data.premiums.life[i].amount, data.premiums.life[i].rate)
                }
                if (data.premiums.life[i]?.premium) {
                    if (data.premiums.life[i].premium < arr_companies_life[min_ind].premium) {
                        min_ind = i
                    }

                    if (data.premiums.life[i].premium < min_premium_life) {
                        min_premium_life = data.premiums.life[i].premium
                    }
                }

            }
            console.log('arr_companies_life', arr_companies_life)
            dispatch(setListCompaniesLife(arr_companies_life))
            dispatch(setIndexLifeMin(min_ind))
            if (arr_companies_life.length > 0)
                dispatch(setInsuranceCompanyLife(arr_companies_life[min_ind]?.insur_comp))


            // +FIND SAME COMPANY POLICIES*******************************************************************************************
            for (let i = 0; i < arr_companies_property.length; i++) {
                for (let j = 0; j < arr_companies_life.length; j++) {
                    if ((arr_companies_property[i].company === arr_companies_life[j].company) && (arr_companies_life[j].company === 'Зетта Страхование')) {
                        dispatch(setIndexPropertySame(i))
                        dispatch(setIndexLifeSame(j))

                    }
                }
            }
            // -FIND SAME COMPANY POLICIES*******************************************************************************************

            // POPULAR
            dispatch(setIndexPropertyPop(index_raiting_p))
            dispatch(setIndexLifePop(index_raiting_l))

            setIsChangeParams(false)
        })
    }



    async function precalc2(pars) {
        console.log('calc2')
        clear_arrs()
        dispatch(setListCompaniesLife([]))
        dispatch(setListCompaniesProperty([]))
        let arr_companies_life = []

        let min_ind = 0
        let min_premium_property = 1000000000
        let min_premium_life = 1000000000
        let index_raiting_p = 0
        let index_raiting_l = 0
        let maxRaitingP = 0
        let maxRaitingL = 0
        let insur_obj = null

        setIsLoad(true);
        const timerCalc = setTimeout(() => {
            setShowMessage(true)
            clearTimeout(timerCalc)
        }, 60000)

        const start = Date.now();
        try {
            await Promise.race([
                dispatch(fetchAbsoluteData(pars)),
                dispatch(fetchZettaData(pars)),
                dispatch(fetchPariData(pars))
            ]);
            console.log('Все асинхронные операции завершены за', Date.now() - start, 'мс');
        } catch (error) {
            console.error('Ошибка при выполнении асинхронной функции:', error);
        }
        console.log('calc2 done 1')
        setIsLoad(false);

        clearTimeout(timerCalc)
        setIsChangeParams(false);

        // pars.company = 'absolute'
        // preCalculate(pars, (data) => {
        //     console.log('abs', data)
        //     insur_obj = { logo: absolut_logo, company: 'Абсолют', premium: data.premiums.property[0].premium, is_manager: false, xname: 'absolutproperty', insur_comp: 'absolute' }
        //     arr_companies_property.push(insur_obj)
        //     dispatch(setListCompaniesProperty(arr_companies_property))
        // });

        // pars.company = 'zetta'
        // preCalculate(pars, (data) => {
        //     console.log('zetta', data)
        //     insur_obj =  { logo: zetta_logo, company: 'Зетта Страхование', premium: data.premiums.property[0].premium, is_manager: false, xname: 'zettaproperty', insur_comp: 'zetta' }
        //     arr_companies_property.push(insur_obj)
        //     dispatch(setListCompaniesProperty(arr_companies_property))
        // });

        // const promises = [];

        // // Функция для оборачивания запроса в промис
        // const sendRequest = (params, company) => {
        //     params.company = company
        //     return new Promise((resolve, reject) => {
        //         preCalculate(params, (data) => {
        //             resolve(data);
        //         });
        //     });
        // };

        // // Создание промисов для каждого запроса

        // const absolutePromise = sendRequest(pars, 'absolute');

        // const zettaPromise = sendRequest(pars, 'zetta');

        // promises.push(absolutePromise, zettaPromise);

        // // Параллельное выполнение запросов
        // Promise.all(promises)
        //     .then((results) => {
        //         // Обработка результатов
        //         results.forEach((data) => {
        //             // Ваш код обработки каждого ответа
        //             if (data.premiums.property.length > 0)
        //                 insur_obj = null
        //                 if (data.premiums.property[0].company === 'absolute') {
        //                     insur_obj = { logo: absolut_logo, company: 'Абсолют', premium: data.premiums.property[0].premium, is_manager: false, xname: 'absolutproperty', insur_comp: 'absolute' }
        //                     if (raitings_p[0] > maxRaitingP) {
        //                         maxRaitingP = raitings_p[0]
        //                         index_raiting_p = arr_companies_property.length - 1
        //                     }
        //                     dispatch(setListCompaniesProperty(arr_companies_property))
        //                     dispatch(setIndexPropertyMin(min_ind))
        //                     if (arr_companies_property.length > 0)
        //                         dispatch(setInsuranceCompanyProperty(arr_companies_property[min_ind]?.insur_comp))
        //                 }
        //                 else if (data.premiums.property[0].company === 'zetta' && data.premiums.property[0].premium) {
        //                     insur_obj =  { logo: zetta_logo, company: 'Зетта Страхование', premium: data.premiums.property[0].premium, is_manager: false, xname: 'zettaproperty', insur_comp: 'zetta' }
        //                     if (raitings_p[1] > maxRaitingP) {
        //                         maxRaitingP = raitings_p[1]
        //                         index_raiting_p = arr_companies_property.length - 1
        //                     }
        //                     dispatch(setListCompaniesProperty(arr_companies_property))
        //                 }

        //                 // if (insur_obj) arr_companies_property.push(insur_obj)
        //                 synchronizedPush(arr_companies_property, insur_obj);
        //             console.log('Received data:', data);
        //         });

        //         // Завершение загрузки
        //         setIsLoad(false);
        //         setIsChangeParams(false);
        //         handleGetDescription();
        //     })
        //     .catch((error) => {
        //         // Обработка ошибок
        //         console.error('Error during parallel requests:', error);
        //     })
        //     .finally(() => {
        //         // Очистка таймера
        //         clearTimeout(timerCalc);
        //     });
    }


    function checkBirthDate(date) {
        if (date.replaceAll(' ', '') === "") {
            setEmptyBirthDate(true)
            return 0
        } else {
            setEmptyBirthDate(false)
            return 1
        }
    }

    function checkGender() {

        if (sex.replaceAll(' ', '') === "") {
            setEmptyGender(true)
            return 0
        } else {
            setEmptyGender(false)
            return 1
        }
    }

    const handleClickCalc = () => {
        console.log('handleClickCalc', birthDateString.replace(/\./g, '-'))
        const bday = birthDateString;
        const [day, month, year] = bday.split('-');
        const formattedDate = `${year}-${month}-${day}`;
        const date = new Date(formattedDate);

        let birthday;
        try {
            birthday = date.toISOString().slice(0, -5);
        }
        catch {
            birthday = new Date('2000-01-01').toISOString().slice(0, -5);
        }
        // const bday = birthDateString.replace(/\./g, '-')
        console.log('handleClickCalc', bday)
        // console.log('handleClickCalc', birthDateString.split('-')[2] + '-' + birthDateString.split('-')[1] + '-' + birthDateString.split('-')[0] )
        if (typeObject !== 'Квартира' && typeObject !== 'Апартаменты') {
            dispatch(setShowPopUpManager(true))
            return
        }
        if (!isChangeParams) return
        setNotCompany(false)
        if (lifeOption) {
            if (checkBirthDate(birthDateString) && checkGender()) {
                precalc2({
                    token: token,
                    cookie: cookie,
                    token_vsk: token_vsk,
                    bank_id: idBank,
                    limit_sum: mortgageBalance,
                    sex: 'М',
                    birthday: birthday
                })
            }
        }
        else
            // precalc({
            //     token: token,
            //     cookie: cookie,
            //     token_vsk: token_vsk,
            //     bank_id: idBank,
            //     limit_sum: mortgageBalance
            // })
            try {
                precalc2({
                    token: token,
                    cookie: cookie,
                    token_vsk: token_vsk,
                    bank_id: idBank,
                    limit_sum: mortgageBalance,
                    sex: 'М',
                    birthday: birthDateString ? birthday : ''
                })
            }
            catch (e) {
                console.log('err calc')
            }
    }

    const handleClickDataPolice = () => {
        setShowDataPolice(!showDataPolice)
    }

    const handleClickLifeOption = () => {
        if (!lifeOption) setIsChangeParams(true)
        dispatch(setLifeOption(!lifeOption))
    }

    const handleClickPropertyOption = () => {
        dispatch(setPropertyOption(!propertyOption))
    }

    const handleClickRegPolice = () => {
        window.ym(90426649, 'reachGoal', 'oformit_onlayn')
        dispatch(setStepCalc('contacts'))
        dispatch(setProcessCalc('contacts'))
        dispatch(setCalcPage('calc'))
    }

    const handleChangeMortgageBalance = (e) => {
        let value = e.target.value;

        // Replace comma with dot if present
        value = value.replace(',', '.');

        setIsChangeParams(true);
        dispatch(setMortgageBalance(value));
    }

    function handleSelectCompanyProperty(index) {
        dispatch(setIndexPropertyMin(index))
        dispatch(setPropertyOption(true))
        dispatch(setInsuranceCompanyProperty(list_companies_property[index].insur_comp))
        setShowListCompanyProperty(false)
    }

    function handleSelectCompanyLife(index) {
        console.log('handleSelectCompanyLife', index)
        dispatch(setIndexLifeMin(index))
        dispatch(setLifeOption(true))
        dispatch(setInsuranceCompanyLife(list_companies_life[index].insur_comp))
        setShowListCompanyLife(false)
    }

    const handleClickAnotherOffers = () => {
        setShowAnotherOffers(true)
    }

    const handleClickCloseAnotherOffers = () => {
        setShowAnotherOffers(false)
    }

    const handliClickSex = () => {
        setShowSexSelecter(!showSexSelecter)
    }

    const handleClickSexMale = () => {
        setIsChangeParams(true)
        setEmptyGender(false)
        dispatch(setSex('Муж.'))
        setShowSexSelecter(false)
    }

    const handleClickSexFeMale = () => {
        setIsChangeParams(true)
        setEmptyGender(false)
        dispatch(setSex('Жен.'))
        setShowSexSelecter(false)
    }

    const handleChangeBirthDate = (e) => {
        setIsChangeParams(true)
        checkBirthDate(e.target.value)
        dispatch(setBirthDateString(e.target.value))
    }

    function hint() {
        console.log('hint')
        var enjoyhint_instance = new EnjoyHint({});

        //simple config. 
        //Only one step - highlighting(with description) "New" button 
        //hide EnjoyHint after a click on the button.
        var enjoyhint_script_steps = [
            {
                'next .hint1': 'Это область ввода параметров для расчёта страхового полиса'
            },
            {
                "next .hint2": "Область вывода результатов от страховых компаний ",
                shape_position: "bottom",
                curveball: 50
            },



            {
                "next .hint3": `Тут вы можете выбрать ваш тип объекта для страхования. Обратите внимание, что онлайн выпуск полиса доступен только для объектов "Квартира" и "Апартаменты". Для остальных типов объектов вам поможет наш менеджер`
            },
            {
                "next .hint4": `Пожалуйста, выберите ваш банк кредитор из списка. Это тот банк, который выдал вам ипотечный кредит.`
            },
            {
                "next .hint5": `Введите сумму остатка по вашему ипотечному кредиту. Это необходимо для расчёта стоимости полиса.`
            },
            {
                "next .hint6": `Нажмите кнопку "Рассчитать", чтобы получить предварительную стоимость полиса от разных страховых компаний. Результаты появятся справа.`
            },
            {
                "next .hint7": `Здесь вы увидите самый выгодный вариант страхования. Подождите немного, пока система получит все котировки. Самый дешевый вариант обновляется в режиме реального времени.`
            },
            {
                "next .hint8": `Нажмите на значок раскрытия строки, чтобы увидеть все доступные страховые компании и их предложения. Вы можете выбрать другую компанию, если хотите.`
            }

        ];

        //set script config
        enjoyhint_instance.set(enjoyhint_script_steps);

        //run Enjoyhint script
        enjoyhint_instance.run();
    }

    function hint2() {
        console.log('hint2')
        var enjoyhint_instance = new EnjoyHint({});

        //simple config. 
        //Only one step - highlighting(with description) "New" button 
        //hide EnjoyHint after a click on the button.
        var enjoyhint_script_steps = [
            {
                'next .hint11': 'Введите ваш мобильный телефон. Не волнуйтесь, мы не передаём ваш номер третьим лицам. Это требование страховых компаний, чтобы они могли оформить полис.'
            },
            {
                "next .hint12": "Введите ваш адрес электронной почты. На него будет отправлена копия страхового полиса. ",
            },
            {
                "next .hint13": `После заполнения полей "Мобильный телефон" и "Адрес электронной почты", нажмите кнопку "Подтвердить телефон". Вам придёт код подтверждения на телефон и электронную почту. `
            },
            {
                "next .hint14": `Введите код, который пришёл на ваш мобильный телефон. Если код не пришёл на телефон, проверьте вашу электронную почту.`
            },
            {
                "next .hint15": `После ввода кода нажмите кнопку "Подтвердить код", чтобы перейти к следующему шагу и завершить оформление полиса.`
            }

        ];

        //set script config
        enjoyhint_instance.set(enjoyhint_script_steps);

        //run Enjoyhint script
        enjoyhint_instance.run();
    }


    useEffect(() => {
        console.log(9)
        getTokens(function (data) {
            console.log('data.res', data)
            dispatch(setToken(data.res.token))
            dispatch(setCookie(data.res.cookie))
            dispatch(setTokenVsk(data.res.token_vsk))
            precalc2({
                token: data.res.token,
                cookie: data.res.cookie,
                token_vsk: data.res.token_vsk,
                bank_id: props.id_bank || idBank,
                limit_sum: props.limit_sum || mortgageBalance,
                sex: 'М',
                birthday: new Date('2000-01-01').toISOString().slice(0, -5)
            })
        })
    }, []);

    // useEffect(() => {
    //     setTimeout(() => hint(), 3000)
    // }, []);

    return (
        <>
            <PreCalcHeader />

            {pre_calc_title}

            {/* PRECALC */}
            <section class="section-calculator-finish section-calculator-finish-2 section-calculator-finish-2-111">
                <div class="conteiner">
                    <div class="section-calculator-finish-contant section-calculator-finish-2-contant section-calculator-finish-2-contant-111"
                        data-da=".section-calculator-finish,500,0">
                        <div class="section-calculator-finish-2-contant-col section-calculator-finish-2-contant-col-1 ">
                            <div class="section-calculator-finish-2-contant-col-vnutr hint1">
                                <div class="form-1 form-111">
                                    <DropDownObject setIsChangeParams={setIsChangeParams} />
                                    <DropDownBank setIsChangeParams={setIsChangeParams} />
                                    <div class="form-1-col form-1-col-3 hint5">
                                        <label for="pet-select">Остаток по ипотеке, ₽</label>
                                        <input
                                            class="pole" id="num" name="ostatok" type="text" placeholder="100 000 ₽"
                                            value={mortgageBalance}
                                            onChange={handleChangeMortgageBalance}
                                        />
                                    </div>
                                </div>

                                <div class="lending-step-text-row lending-step-text-row-111">
                                    <div class="lending-step-text-item lending-step-text-item-1"
                                        onClick={handleClickPropertyOption}
                                    >
                                        <label
                                            className={"lending-step-text-item-vnutr lending-step-text-item lending-step-text-item-1 lending-step-text-3 checkbox-1-111" +
                                                (!propertyOption ? ' checked-111' : '')
                                            }
                                            for="zakon" id="checkbox-1-111">

                                            <img src={icon_s3_1} alt="home" />Недвижимость
                                        </label>
                                    </div>
                                    <div class="lending-step-text-item lending-step-text-item-2"
                                        onClick={handleClickLifeOption}
                                    >
                                        <label
                                            class={"lending-step-text-item-vnutr lending-step-text-item lending-step-text-item-1 lending-step-text-3 checkbox-1-112" +
                                                (lifeOption ? ' checked-112' : '')
                                            }
                                            for="zakon-1" id="checkbox-1-112">

                                            <img src={icon_s3_2} alt="home" />Жизнь и здоровье
                                        </label>
                                    </div>
                                </div>

                                {lifeOption &&
                                    <div class="tab-body-blok-info-row tab-body-blok-info-row-2 tab-body-blok-info-row-2-111"
                                        id="tab-body-blok-info-row-2-111">
                                        <div
                                            class="tab-body-blok-info-element tab-body-blok-info-element-4 tab-body-blok-info-element-4-111">
                                            <div class={"tab-body-blok-info-element-vnutr " + (emptyBirthDate ? "redBorder" : "")}>
                                                <label class="section-two-banks-text-2" for="pet-select">
                                                    Дата рождения</label>
                                                {/* <input class="pole pole-step-2 mask-date" id="pole-1.4" name="ostatok"
                                                    type="text" value="" onkeyup="success()" placeholder="ДД.ММ.ГГГГ" /> */}
                                                <InputMask mask="99.99.9999"
                                                    placeholder="ДД.ММ.ГГГГ"
                                                    className="pole pole-step-2 mask-date "

                                                    value={birthDateString}
                                                    onChange={handleChangeBirthDate} />
                                            </div>
                                        </div>


                                        <div
                                            class="tab-body-blok-info-element tab-body-blok-info-element-5 tab-body-blok-info-element-5-111"
                                        >
                                            <div class="form-1-col form-1-col-1 form-1-col-111">
                                                <div class={"tab-body-blok-info-element-vnutr " + (emptyGender ? "redBorder" : "")}>
                                                    <div class="form-group">
                                                        <div class="">
                                                            <p class="section-two-banks-text-2">Пол</p>
                                                            <button onClick={handliClickSex} class="dropdown__button pole pole-step-2">{sex}</button>
                                                            {showSexSelecter &&
                                                                <ul class="dropdown__list">
                                                                    <li onClick={handleClickSexMale} class="dropdown__list-item" data-value="Муж.">
                                                                        Муж.
                                                                    </li>
                                                                    <li onClick={handleClickSexFeMale} class="dropdown__list-item" data-value="Жен.">
                                                                        Жен.</li>
                                                                </ul>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                }
                                <div class={"button button-1 button-novostroiki-1 button-step-500 hint6" + ((isChangeParams && !isLoad) ? 'btn_calc_active' : ' button-111')} id="button-111"
                                    onClick={handleClickCalc}
                                >
                                    Рассчитать
                                </div>
                            </div>
                        </div>
                        <div class="section-calculator-finish-2-contant-col section-calculator-finish-2-contant-col-2">
                            <div class="section-calculator-finish-2-contant-col-vnutr section-calculator-finish-2-contant-col-vnutr-111 hint2">
                                {(isChangeParams || isLoad) &&
                                    <div class="tab-body-blok-info-animation tab-body-blok-info-animation-111"
                                        id="tab-body-blok-info-animation-500">
                                        {isLoad &&
                                            <div class="blok-info-animation">
                                                <div class="circle-box" id="circle-box">
                                                    <div class="circle  slideInDown wow"></div>
                                                    <div class="circle  slideInDown1 wow"></div>
                                                    <div class="circle  slideInDown2 wow"></div>
                                                </div>
                                            </div>
                                        }
                                        {!isLoad &&
                                            <p class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-111"
                                                id="tab-body-blok-info-animation-text">Вы
                                                изменили параметры. Нажмите “Рассчитать”, чтобы снова рассчитать стоимость полиса.
                                            </p>
                                        }
                                    </div>
                                }

                                {notCompany && !isChangeParams && !isLoad &&
                                    <>
                                        {/* <div class="tab-body-blok-info-animation tab-body-blok-info-animation-111"
                                            id="tab-body-blok-info-animation-500"> */}
                                        <p class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-111"
                                            id="tab-body-blok-info-animation-text">
                                            По заданным Вами параметрам мы не можем подобрать страховую компанию, оформите заявку и менеджер Вам поможет.
                                        </p>
                                        {/* </div> */}
                                        <div onClick={() => dispatch(setShowPopUpManager(true))} class="button button-1 button-novostroiki-1 button-step-4001">
                                            Оформить с менеджером
                                        </div>
                                    </>
                                }

                                {!isChangeParams && !notCompany && !isLoad &&
                                    <>
                                        <div class="tab-body-blok-info-401 tab-body-blok-info-401-element-2-000 hint7"
                                            id="tab-body-blok-info-401-element-2-000">
                                            <p class="banner-text banner-text-1">Самый выгодный</p>
                                            <div class="tab-body-blok-info-401-element tab-body-blok-info-401-element-1111">
                                                <div class="form-1-col form-1-col-1 form-1-col-1111">
                                                    <div class="form-group">
                                                        <div class="dropdown dropdown-111">
                                                            <img class="img-1" src={icon_s3_1} alt="" />
                                                            <img class="img-2" src={rifizen} alt="" />
                                                            <img class="img-3" src="img/alfa.png" alt="" />
                                                            <img class="img-4" src="img/vtb.svg" alt="" />

                                                            <button onClick={handleClickCompanyProperty} class="dropdown__button dropdown__button-111 hint8">
                                                                {propertyOption ? list_companies_property[index_property_min]?.company : 'Добавить страхование имущества'}
                                                            </button>
                                                            {showListCompanyProperty &&
                                                                <ul class="dropdown__list dropdown__list-111">
                                                                    {
                                                                        list_companies_property.map((company, index) => {
                                                                            return (
                                                                                <li onClick={() => handleSelectCompanyProperty(index)} key={index} class="drop-img-1 dropdown__list-item dropdown__list-item-111 dropdown__list-item-2"
                                                                                    data-value="СБЕР Страхование">
                                                                                    <img class="bank-image bank-image-2" src={company.logo}
                                                                                        alt="banks"
                                                                                    />
                                                                                    {company.company}
                                                                                    <span>{company.premium}</span>
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }

                                                                </ul>
                                                            }
                                                            {/* <input type="text" name="select-category" value=""
                                                                class="dropdown__input-hidden" /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-body-blok-info-401-element tab-body-blok-info-401-element-2 tab-body-blok-info-401-element-1112 tab-body-blok-info-401-element-2-111"
                                                id="tab-body-blok-info-401-element-2-111">
                                                <div class="form-1-col form-1-col-1 form-1-col-1111">
                                                    <div class="form-group">
                                                        <div class="dropdown dropdown-111">
                                                            <img class="img-5" src={heart} alt="" />
                                                            <button onClick={handleClickCompanyLife} class="dropdown__button dropdown__button-111">
                                                                {lifeOption ? list_companies_life[index_life_min]?.company : 'Добавить страхование жизни'}
                                                            </button>
                                                            {showListCompanyLife &&
                                                                <ul class="dropdown__list dropdown__list-111">
                                                                    {
                                                                        list_companies_life.map((company, index) => {
                                                                            return (
                                                                                <li onClick={() => handleSelectCompanyLife(index)} key={index} class="drop-img-6 dropdown__list-item dropdown__list-item-111 dropdown__list-item-2"
                                                                                    data-value="СБЕР Страхование">
                                                                                    <img class="bank-image bank-image-2" src={company.logo}
                                                                                        alt="banks"
                                                                                    />
                                                                                    {company.company}
                                                                                    <span>{lifeOption && company.premium}</span>
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }

                                                                </ul>
                                                            }
                                                            {/* <input type="text" name="select-category" value=""
                                                                class="dropdown__input-hidden" /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-body-4-blok-price">
                                                <div class="tab-body-4-price-1">
                                                    {digitNumber(Math.round(100 * (((propertyOption && list_companies_property[index_property_min]?.premium) + (lifeOption && list_companies_life[index_life_min]?.premium)) / (100 - 10))).toString())}
                                                </div>
                                                <div class="tab-body-4-price-2">
                                                    -20%
                                                </div>
                                                <div class="tab-body-4-price-3">
                                                    {digitNumber(Math.round(((propertyOption && list_companies_property[index_property_min]?.premium) + (lifeOption && list_companies_life[index_life_min]?.premium))).toString()) + ' ₽'}
                                                </div>
                                            </div>
                                            <div class="tab-body-4-dopinfo-blok-link">
                                                <p onClick={handleClickDataPolice} class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-1">
                                                    Данные полиса
                                                    <img class="icon-down-arrow icon-down-arrow-401" src={arrow_dropdown_gray}
                                                        alt="arrow icon" />
                                                </p>
                                            </div>
                                            {showDataPolice &&
                                                <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-1"
                                                    id="tab-body-4-blok-dopinfo-1">
                                                    <div class="tab-body-4-blok-dopinfo-col">
                                                        <img class="icon-home-gray" src={icon_home_gray} alt="home" />
                                                        <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-1">
                                                            Страхование конструктивных
                                                            элементов недвижимости (крыша,
                                                            окна, лестницы, стены, перекрытия, перегородки).<br />
                                                            Риски в соответствии с требованием банка.<br />
                                                            Пожар, взрыв, нанесение вреда в результате стихийных бедствий,
                                                            постороннее воздействие (падение деревьев и прочее).</p>
                                                    </div>
                                                    <div class="tab-body-4-blok-dopinfo-col">
                                                        <img class="icon-home-gray" src={icon_heart_gray} alt="home" />
                                                        <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-2">
                                                            Страхование от несчастных
                                                            случаев и болезней.<br />
                                                            Риски в соответствии с требованием банка.<br />
                                                            Установление инвалидности 1–2 группы в результате несчастного случая
                                                            или болезни.<br />
                                                            Смерть в результате несчастного случая или болезни.</p>
                                                    </div>
                                                </div>
                                            }
                                            <div onClick={handleClickRegPolice} class="button button-1 button-novostroiki-1 button-step-4001">
                                                Оформить онлайн
                                            </div>
                                        </div>

                                        <div class="tab-body-4-dopinfo-blok-link tab-body-4-dopinfo-blok-link-111"
                                            id="tab-body-4-dopinfo-blok-link-111">
                                            {!showAnotherOffers &&
                                                <p onClick={handleClickAnotherOffers} class="tab-body-4-dopinfo-link tab-body-4-dopinfo-link-111"
                                                    id="tab-body-4-dopinfo-link-111">
                                                    Другие предложения
                                                    <img class="icon-down-arrow icon-down-arrow-401 icon-down-arrow-401-111"
                                                        src={arrow_dropdown_gray} alt="arrow icon" />
                                                </p>
                                            }
                                            {showAnotherOffers &&
                                                <p onClick={handleClickCloseAnotherOffers} class="tab-body-4-dopinfo-link tab-body-4-dopinfo-link-112"
                                                    id="tab-body-4-dopinfo-link-112">
                                                    Скрыть предложения
                                                    <img class="icon-down-arrow icon-down-arrow-401 icon-down-arrow-401-111"
                                                        src={arrow_dropdown_gray} alt="arrow icon" />
                                                </p>
                                            }
                                        </div>
                                    </>
                                }
                                {showAnotherOffers &&
                                    <div class="blok-1111" id="blok-1111">
                                        <OfferCard
                                            type={'Самый популярный'}
                                            company_property={list_companies_property[indexPropertyPop]?.company}
                                            company_life={list_companies_life[indexLifePop]?.company}
                                            premium_property={list_companies_property[indexPropertyPop]?.premium}
                                            premium_life={list_companies_life[indexLifePop]?.premium}
                                        />

                                        <OfferCard
                                            type={'В одной компании'}

                                            company_property={list_companies_property[indexPropertySame]?.company}
                                            company_life={list_companies_life[indexLifeSame]?.company}
                                            premium_property={list_companies_property[indexPropertySame]?.premium}
                                            premium_life={list_companies_life[indexLifeSame]?.premium}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <PreCalcFooter />
            {showPopUpManager &&
                <FormManager />
            }

            {showMessage &&
                <FormWait setShow={setShowMessage} />
            }


            {false && <div class="b-popup" id="popup3">
                <div class="b-popup-vnutr"></div>
                <div class="b-popup-content b-popup-content-2">
                    <p class="popup-title popup-title-2">Контактная информация</p>
                    <p class="popup-text">Что бы зафиксировать цену и получить другие предложения, оставьте контактную
                        информацию: Наш менеджер свяжется в ближайшее время!</p>
                    <form class="form-popup">
                        <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-3">
                            <label for="select-1">Имя</label>
                            <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text" placeholder=""
                                required />
                        </div>
                        <div class="one-ryad one-ryad-popup one-ryad-popup-2 one-ryad-popup-user one-ryad-popup-user-4">
                            <label for="select-1">Телефон</label>
                            <input class="pole-popup pole-popup-user pole-popup-2" name="Телефон" type="tel" placeholder="+7"
                                pattern="^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$" required />
                        </div>
                        <div class="one-ryad one-ryad-popup one-ryad-popup-3  one-ryad-popup-user one-ryad-popup-user-5">
                            <div class="form-group">
                                <div class="dropdown">
                                    <label for="select-1">Удобный способ связи</label>
                                    <button
                                        class="dropdown__button dropdown__button-popup dropdown__button-popup-user">Телеграм</button>
                                    <ul class="dropdown__list">
                                        <li class="dropdown__list-item" data-value="Телеграм">Телеграм</li>
                                        <li class="dropdown__list-item" data-value="Ватсап">Ватсап</li>
                                        <li class="dropdown__list-item" data-value="Апартаменты">Вайбер</li>
                                        <li class="dropdown__list-item" data-value="Апартаменты">ВКонтакте</li>
                                    </ul>
                                    {/* <input type="text" name="select-category" value="" class="dropdown__input-hidden" /> */}
                                </div>
                            </div>
                        </div>
                        <div class="one-ryad one-ryad-popup one-ryad-popup-4  one-ryad-popup-user one-ryad-popup-user-6">
                            <label for="select-1">Адрес объекта</label>
                            <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text" placeholder=""
                                required />
                        </div>
                        <div class="one-ryad one-ryad-popup one-ryad-popup-5  one-ryad-popup-user one-ryad-popup-user-7">
                            <label for="select-1">Дата начала действия полиса</label>
                            <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text"
                                placeholder="ДД.ММ.ГГГГ" required />
                        </div>
                        <div class="one-ryad one-ryad-popup one-ryad-popup-6  one-ryad-popup-user one-ryad-popup-user-8">
                            <label for="select-1">Комментарий</label>
                            <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text" placeholder=""
                                required />
                        </div>
                        <button class="button button-1 button-popup-1">Оставить заявку</button>
                    </form>
                    <a class="popup-close" href="javascript:PopUpHide3()"><img src="img/close.svg" alt="close" /></a>
                </div>
            </div>}

        </>
    );
}



